import { useState } from "react";
import CreateNewPlanForm from "../plans-management-components/CreateNewPlanForm";
import { Content } from "../../utils/Content";
import { Typography, Grid, Box, Skeleton } from "@mui/material";
import { useMenu } from "../../context/MenuOpenContext";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AlertDetails from "../alert-components/AlertDetails";

export default function AlertDetailsLayout() {
  const { isOpen } = useMenu();
  const { t } = useTranslation();

  return (
    <Content open={isOpen}>
      <Grid container spacing={1} ml={{ xs: 0, sm: 2 }} mb={2}>
        <Link to={"/alerts"} className="nav-link_back" underline="none">
          <ArrowBackIcon sx={{ marginRight: "5px" }} />
          {t("back.button")}
        </Link>
      </Grid>
      <AlertDetails />
    </Content>
  );
}
